import Icon from '../components/Icon.vue'

Icon.register({
  'grip-lines': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 288H16C7.2 288 0 295.2 0 304V336C0 344.8 7.2 352 16 352H496C504.8 352 512 344.8 512 336V304C512 295.2 504.8 288 496 288zM496 160H16C7.2 160 0 167.2 0 176V208C0 216.8 7.2 224 16 224H496C504.8 224 512 216.8 512 208V176C512 167.2 504.8 160 496 160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grip-lines.js
// module id = afei
// module chunks = 144